function normalizeEnvValue(value?: string) {
  const trimmed = value?.trim();
  return trimmed ? trimmed : "";
}

function getDefaultApiBaseUrl() {
  const configured = normalizeEnvValue(process.env.REACT_APP_API_BASE_URL);
  if (configured) return configured;
  return process.env.NODE_ENV === "production" ? "/api" : "http://localhost:8000";
}

export const GOOGLE_OAUTH_POPUP_COMPLETE_PATH = "/google-link/complete";
export const LINE_OAUTH_POPUP_COMPLETE_PATH = "/line-link/complete";
export const LINE_OAUTH_CALLBACK_PATH = "/line-callback.html";
export const LINE_REGISTER_CALLBACK_PATH = "/line-register/callback";

function buildSameOriginUrl(pathname: string) {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${pathname}`;
  }

  return pathname;
}

export function resolveGoogleOAuthPopupCompleteUrl(pathname = GOOGLE_OAUTH_POPUP_COMPLETE_PATH) {
  return buildSameOriginUrl(pathname);
}

export function resolveLineOAuthPopupCompleteUrl(pathname = LINE_OAUTH_POPUP_COMPLETE_PATH) {
  return buildSameOriginUrl(pathname);
}

export function resolveLineOAuthCallbackUrl(pathname = LINE_OAUTH_CALLBACK_PATH) {
  return buildSameOriginUrl(pathname);
}

export function resolveLineRegisterCallbackUrl(pathname = LINE_REGISTER_CALLBACK_PATH) {
  return buildSameOriginUrl(pathname);
}

export const API_BASE_URL = getDefaultApiBaseUrl();

// Comma-separated list of external fallback API hosts (HTTPS only).
// If unset, only same-origin and window.location.origin fallbacks are attempted.
// SECURITY: values are embedded in the built JS bundle — do NOT include internal
// origin hostnames (e.g. origin-api.*) that should not be publicly known.
export const API_FALLBACK_HOSTS: string[] = normalizeEnvValue(process.env.REACT_APP_API_FALLBACK_HOSTS)
  ? normalizeEnvValue(process.env.REACT_APP_API_FALLBACK_HOSTS)
      .split(",")
      .map((h) => h.trim().replace(/\/$/, ""))
      .filter((h) => h.startsWith("https://"))
  : [];

export const LINE_OFFICIAL_ACCOUNT_URL = normalizeEnvValue(process.env.REACT_APP_LINE_OFFICIAL_ACCOUNT_URL);
export const GOOGLE_CLIENT_ID = normalizeEnvValue(process.env.REACT_APP_GOOGLE_CLIENT_ID);
export const GOOGLE_SSO_BYPASS = process.env.REACT_APP_GOOGLE_SSO_BYPASS === "true";

// 本番ビルドで誤って bypass が有効になっていた場合は即クラッシュさせる
if (process.env.NODE_ENV === "production" && GOOGLE_SSO_BYPASS) {
  throw new Error("REACT_APP_GOOGLE_SSO_BYPASS must not be enabled in production builds");
}
